export type Lang = "de" | "en";

type Pair = { de: string; en: string };

export const STRINGS = {
  // Language toggle
  "lang.de": { de: "DE", en: "DE" },
  "lang.en": { de: "EN", en: "EN" },
  "lang.label": { de: "Sprache", en: "Language" },

  // Benzo page
  "benzo.title": { de: "Benzo-Effekte-Vergleich", en: "Benzo Effects Comparison" },
  "benzo.filter.all": { de: "Alle", en: "All" },
  "benzo.col.substance": { de: "Substanz", en: "Substance" },
  "benzo.col.class": { de: "Klasse", en: "Class" },
  "benzo.col.halflife": { de: "t½ (h)", en: "t½ (h)" },
  "benzo.col.equiv": { de: "Äquivalenz", en: "Equivalence" },
  "benzo.col.typicalDose": { de: "Typ. Dosis", en: "Typical Dose" },
  "benzo.col.anxiolytic": { de: "Angst", en: "Anxiolytic" },
  "benzo.col.sedative": { de: "Sedierung", en: "Sedative" },
  "benzo.col.relaxant": { de: "Relaxant", en: "Muscle Relaxant" },
  "benzo.col.anticonvulsant": { de: "Anticonvulsant", en: "Anticonvulsant" },
  "benzo.col.dependence": { de: "Abhängigkeit", en: "Dependence" },
  "benzo.warnIcon": { de: "Sonderhinweis - siehe Fußnote", en: "Special note - see footnote" },
  "benzo.detail.maxDaily": { de: "Max Tagesdosis", en: "Max Daily" },
  "benzo.detail.anticonvulsant": { de: "Anticonvulsant", en: "Anticonvulsant" },
  "benzo.detail.typicalDose": { de: "Typische Dosis", en: "Typical dose" },
  "benzo.detail.typicalDoseNote": {
    de: "Orientierungswert ohne Indikation, Applikationsweg, Altersgruppe und Zulassungsregion. Keine Dosierungsempfehlung.",
    en: "Orientation value without indication, route of administration, age group and licensing region. Not a dosing recommendation.",
  },
  "benzo.detail.profileTitle": { de: "Wirkprofil (redaktionelle Einschätzung)", en: "Effect profile (editorial estimate)" },
  "benzo.detail.profileNote": {
    de: "Ordinale Einschätzung ohne validierte Messskala und ohne substanzspezifischen Einzelbeleg. Nicht zwischen Substanzklassen vergleichbar.",
    en: "Ordinal estimate without a validated measurement scale and without a substance-specific source. Not comparable across substance classes.",
  },
  "benzo.detail.notComparable": {
    de: "Andere Substanzklasse: die Punktwerte sind nicht mit Benzodiazepinen vergleichbar.",
    en: "Different substance class: the dot values are not comparable to benzodiazepines.",
  },
  "benzo.pharma.halfLife": { de: "Halbwertszeit", en: "Half-Life" },
  "benzo.pharma.activeMetabolites": { de: "Aktive Metaboliten", en: "Active Metabolites" },
  "benzo.pharma.onset": { de: "Wirkeintritt", en: "Onset of Action" },
  "benzo.pharma.peak": { de: "Plasmaspitze", en: "Peak Level" },
  "benzo.pharma.duration": { de: "Wirkdauer", en: "Duration Category" },
  "benzo.pharma.lipophilicity": { de: "Lipophilie", en: "Lipophilicity" },
  "benzo.pharma.metabolism": { de: "Hauptmetabolismus", en: "Primary Metabolic Pathway" },
  "benzo.pharma.special": { de: "Besondere Populationen", en: "Special Populations" },

  // Matrix page
  "matrix.title": { de: "Interaction Matrix (Wechselwirkungen)", en: "Interaction Matrix (Interaction Checker)" },
  "matrix.pickSubstance": { de: "-- Substanz wählen --", en: "-- Select substance --" },
  "matrix.pickDifferent": { de: "Bitte zwei verschiedene Substanzen wählen.", en: "Please pick two different substances." },
  "matrix.noEntry": { de: "Kein Dateneintrag verfügbar.", en: "No data entry available." },
  "matrix.noCombine": { de: "Nicht kombinieren", en: "Do not combine" },
 "matrix.noData": { de: "keine Daten", en: "no data" },
 "matrix.scrollHint": { de: "Tipp: horizontal scrollen, um alle Substanzen zu sehen.", en: "Tip: scroll horizontally to see all substances." },
  "matrix.disclaimer": {
    de: "Diese Tabelle dient Informationszwecken. Kombinationen können individuell variieren. Dosisangaben in den Infokarten gelten nur für den Monokonsum, bei Kombinationen beide Substanzen deutlich niedriger dosieren. Kein Ersatz für medizinische Beratung.",
    en: "This table is for informational purposes. Combinations may vary individually. Dose figures in the info cards apply to single-substance use only, when combining dose both substances clearly lower. Not a substitute for medical advice.",
  },

  "matrix.noAssessment": { de: "Keine Bewertung vorhanden", en: "No assessment available" },
  "matrix.noAssessmentHint": {
    de: "Für diese Kombination liegt bisher keine Bewertung vor. Keine Bewertung bedeutet nicht, dass die Kombination sicher ist.",
    en: "There is no assessment for this combination yet. No assessment does not mean the combination is safe.",
  },
  "matrix.legendNote": {
    de: "Unbekannt bedeutet nicht sicher. Niedriges Zusatzrisiko bedeutet nicht risikofrei. Die Einstufung ersetzt keine individuelle medizinische Prüfung.",
    en: "Unknown does not mean safe. Low additional risk does not mean risk-free. This classification is no substitute for an individual medical assessment.",
  },
  "matrix.dataWarning.title": { de: "Datenprüfung", en: "Data validation" },
  "matrix.dataWarning.invalid": {
    de: "{n} Bewertung(en) enthalten einen unbekannten Wert und werden neutral als Unbekannt dargestellt, nicht als niedriges Risiko.",
    en: "{n} assessment(s) contain an unknown value and are shown neutrally as unknown, not as low risk.",
  },
  "matrix.dataWarning.unresolved": {
    de: "{n} Kombination(en) verweisen auf Substanzen, die nicht aufgelöst werden konnten, und fehlen daher in der Matrix.",
    en: "{n} combination(s) reference substances that could not be resolved and are therefore missing from the matrix.",
  },
  "matrix.loadError": {
    de: "Die Matrix konnte nicht geladen werden. Bitte die Seite neu laden. Bleibt der Fehler, später erneut versuchen.",
    en: "The matrix could not be loaded. Please reload the page. If the error persists, try again later.",
  },

  // Matrix AI explanation
  "ai.title": { de: "Frage zu einer Kombination", en: "Question about a combination" },
  "ai.intro": {
    de: "Stelle eine Frage zu der oben gewählten Kombination. Die Antwort wird ausschließlich aus den hier gespeicherten Bewertungen und Quellen gebildet und ersetzt keine individuelle medizinische Prüfung.",
    en: "Ask a question about the combination selected above. The answer is built solely from the assessments and sources stored here and does not replace an individual medical review.",
  },
  "ai.pairHint": {
    de: "Bitte zuerst oben zwei verschiedene Substanzen wählen.",
    en: "Please select two different substances above first.",
  },
  "ai.questionLabel": { de: "Deine Frage", en: "Your question" },
  "ai.placeholder": {
    de: "Zum Beispiel: Worauf muss ich bei dieser Kombination besonders achten?",
    en: "For example: what should I watch out for with this combination?",
  },
  "ai.submit": { de: "Frage senden", en: "Send question" },
  "ai.loading": { de: "Die Einordnung wird erstellt.", en: "Generating the explanation." },
  "ai.answerTitle": { de: "Einordnung", en: "Explanation" },
  "ai.sourcesTitle": { de: "Verwendete Quellen", en: "Sources used" },
  "ai.disclaimer": {
    de: "Diese Einordnung stammt aus den gespeicherten Bewertungen dieser Seite und ersetzt keine individuelle medizinische Prüfung.",
    en: "This explanation comes from the assessments stored on this site and does not replace an individual medical review.",
  },
  "ai.noAssessment": {
    de: "Für diese Kombination liegt keine Bewertung vor. Es wird daher keine Einordnung erzeugt. Kombiniere im Zweifel nicht, bleibe nicht allein und rufe bei Anzeichen einer Notlage sofort den Rettungsdienst.",
    en: "There is no assessment for this combination, so no explanation is generated. When in doubt do not combine, do not stay alone, and call emergency services at the first sign of a crisis.",
  },
  "ai.emergencyLink": { de: "Notfallhinweise ansehen", en: "View emergency guidance" },
  "ai.error.limit": {
    de: "Das Stundenlimit von 10 Fragen ist erreicht. Bitte später erneut versuchen.",
    en: "The hourly limit of 10 questions has been reached. Please try again later.",
  },
  "ai.error.credits": {
    de: "Die Einordnung ist derzeit nicht verfügbar, weil das Guthaben für die Modellnutzung aufgebraucht ist. Bitte später erneut versuchen.",
    en: "The explanation is currently unavailable because the model usage credits are exhausted. Please try again later.",
  },
  "ai.error.denied": {
    de: "Die Anfrage wurde vom Modellanbieter abgelehnt. Bitte formuliere die Frage sachlich zu der gewählten Kombination.",
    en: "The request was refused by the model provider. Please phrase the question factually about the selected combination.",
  },
  "ai.error.config": {
    de: "Die Einordnung ist wegen einer fehlenden Konfiguration nicht verfügbar. Bitte melde das dem Seitenbetreiber.",
    en: "The explanation is unavailable due to a missing configuration. Please report this to the site owner.",
  },
  "ai.error.unavailable": {
    de: "Die Einordnung konnte nicht erstellt werden. Bitte später erneut versuchen.",
    en: "The explanation could not be generated. Please try again later.",
  },
  "ai.error.empty": {
    de: "Es wurde keine verwertbare Antwort erzeugt. Bitte die Frage anders formulieren.",
    en: "No usable answer was generated. Please rephrase the question.",
  },
  "ai.error.unverified": {
    de: "Die Antwort war nicht sauber mit den gespeicherten Quellen belegt und wird deshalb nicht angezeigt. Bitte die Frage anders formulieren.",
    en: "The answer was not properly backed by the stored sources and is therefore not shown. Please rephrase the question.",
  },

  // Matrix accessibility
  "matrix.tableDescription": {
    de: "Raster aller Substanzkombinationen. Mit den Pfeiltasten zwischen den Zellen bewegen, mit Eingabe- oder Leertaste die Details öffnen.",
    en: "Grid of all substance combinations. Move between cells with the arrow keys, open details with Enter or Space.",
  },
  "matrix.cellAction": { de: "Details öffnen", en: "Open details" },
  "matrix.cellRisk": { de: "Risiko", en: "Risk" },
  "matrix.cellMarkers": { de: "Marker", en: "Markers" },
  "matrix.cellSelf": { de: "Gleiche Substanz, keine Kombination", en: "Same substance, no combination" },

  // Matrix levels
  "level.safe": { de: "Niedriges Zusatzrisiko", en: "Low additional risk" },
  "level.unknown": { de: "Unbekannt / unzureichend untersucht", en: "Unknown / insufficiently studied" },
  "level.synergy": { de: "Synergie / Potenzierung", en: "Synergy / potentiation" },
  "level.reduced": { de: "Reduzierte Effekte", en: "Reduced effects" },
  "level.caution": { de: "Vorsicht (mittleres Risiko)", en: "Caution (moderate risk)" },
  "level.highrisk": { de: "Hohes Risiko", en: "High risk" },
  "level.contra": { de: "Gefährlich", en: "Dangerous" },

  // Matrix mechanistic markers
  "marker.legend.title": { de: "Mechanistische Marker", en: "Mechanistic markers" },
  "marker.legend.intro": {
    de: "Diese Marker zeigen die ART der Gefahr zusätzlich zur Risikofarbe - sie sind keine Entwarnung, sondern eine zusätzliche Warnung.",
    en: "These markers indicate the TYPE of harm in addition to the risk color - they are not an all-clear, but an additional warning.",
  },
  "marker.legend.maoi": {
    de: "MAOI bezeichnet hier pharmazeutische MAO-Hemmer (verschriebene Antidepressiva).",
    en: "MAOI here refers to pharmaceutical MAO inhibitors (prescription antidepressants).",
  },
  "marker.serotonin": { de: "Serotonin-Gefahr (Serotonin-Syndrom)", en: "Serotonin risk (serotonin syndrome)" },
  "marker.cardio": { de: "Herz-Kreislauf-Gefahr", en: "Cardiovascular risk" },
  "marker.serotonin_cardio": { de: "Serotonin + Kreislauf zugleich", en: "Serotonin + cardiovascular combined" },
  "marker.respiratory": { de: "Atemdepression", en: "Respiratory depression" },


  // Combo info sheet
  "combo.close": { de: "Schließen", en: "Close" },
  "combo.loading": { de: "Lade Daten…", en: "Loading data…" },
  "combo.error": { de: "Fehler", en: "Error" },
  "combo.noData": { de: "Keine Daten", en: "No data" },
  "combo.emptyData": { de: "noch keine Daten", en: "no data yet" },
  "combo.section.effects": { de: "Wirkungen", en: "Effects" },
  "combo.section.adverse": { de: "Nebenwirkungen", en: "Adverse effects" },
  "combo.section.routes": { de: "Konsumformen & Dosis", en: "Routes & dose" },
  "combo.doseDisclaimer": {
    de: "Dosisangaben sind nur eine vorsichtige Orientierung für den Monokonsum, also für diese eine Substanz allein, und gelten nur für getestete, bekannte Substanzen. Niedrig anfangen, Wirkung abwarten, Körpergewicht und Toleranz beachten. Reinheit ist oft unbekannt, im Zweifel Drug-Checking nutzen. Rot markierte Stufen sind besonders riskant.",
    en: "Dose figures are only a cautious orientation for single-substance use, meaning this one substance on its own, and apply only to tested, known substances. Start low, wait for the effects, mind body weight and tolerance. Purity is often unknown, use drug checking if in doubt. Tiers marked in red are especially risky.",
  },
  "combo.monoDose.title": {
    de: "Dosisangaben gelten nur für Monokonsum",
    en: "Dose figures apply to single-substance use only",
  },
  "combo.monoDose.body": {
    de: "Alle Dosisangaben auf dieser Karte beziehen sich auf eine Substanz allein. Für diese Kombination gelten sie nicht. Wer kombiniert, dosiert grundsätzlich beide Substanzen deutlich niedriger als beim Einzelkonsum, nimmt sie zeitversetzt statt gleichzeitig ein und legt erst nach, wenn die Wirkung beider klar einschätzbar ist.",
    en: "Every dose figure on this card refers to one substance on its own. They do not apply to this combination. When combining, dose both substances clearly lower than you would on their own, take them staggered rather than at the same time, and only redose once the effects of both can be judged clearly.",
  },
  "combo.monoDose.dangerous": {
    de: "Diese Kombination ist als unsicher oder gefährlich eingestuft. Auch eine niedrigere Dosis macht sie nicht sicher. Am sichersten ist, sie nicht zu kombinieren.",
    en: "This combination is rated unsafe or dangerous. A lower dose does not make it safe. The safest choice is not to combine them.",
  },
  "combo.monoDose.unknown": {
    de: "Für diese Kombination gibt es keine gesicherte Einschätzung. Fehlende Daten bedeuten nicht, dass sie harmlos ist.",
    en: "There is no reliable assessment for this combination. Missing data does not mean it is harmless.",
  },
  "combo.monoDose.short": {
    de: "Nur für Monokonsum. In Kombination beide Substanzen deutlich niedriger dosieren.",
    en: "Single-substance use only. In combination, dose both substances clearly lower.",
  },
  "combo.section.summary": { de: "Zusammenfassung", en: "Summary" },
  "combo.section.mechanism": { de: "Mechanismus", en: "Mechanism" },
  "combo.section.combined": { de: "Kombinierte Effekte", en: "Combined effects" },
  "combo.section.risks": { de: "Risiken & Begründung", en: "Risks & rationale" },
  "combo.section.harmReduction": { de: "Harm Reduction", en: "Harm reduction" },
  "combo.onset": { de: "Wirkeintritt", en: "Onset" },
  "combo.duration": { de: "Dauer", en: "Duration" },
  "combo.noDescription": { de: "Noch keine detaillierte Beschreibung hinterlegt.", en: "No detailed description available yet." },
  "combo.noInteractionDetails": { de: "Für diese Kombination liegt noch keine detaillierte Beschreibung vor.", en: "No detailed description available for this combination yet." },

  // Rich interaction content (consumer + expert)
  "ic.kernaussage": { de: "Kernaussage", en: "Key point" },
  "ic.section.wasPassiert": { de: "Was passiert", en: "What happens" },
  "ic.section.fuerWen": { de: "Für wen besonders gefährlich", en: "Especially dangerous for" },
  "ic.section.warnzeichen": { de: "Warnzeichen, sofort Notruf 112", en: "Warning signs, call emergency immediately" },
  "ic.section.wennPassiert": { de: "Wenn es schon passiert, was hilft", en: "If it already happened, what helps" },
  "ic.section.experte": { de: "Für Kenner: Mechanismus und Pharmakologie", en: "For experts: mechanism and pharmacology" },
  "ic.section.quellen": { de: "Quellen", en: "Sources" },
  "ic.cite.show": { de: "Quelle {n} anzeigen", en: "Show source {n}" },
  "ic.evidenz.label": { de: "Belege", en: "Evidence" },
  "ic.evidenz.gesichert": { de: "gesichert", en: "established" },
  "ic.evidenz.wahrscheinlich": { de: "wahrscheinlich", en: "likely" },
  "ic.evidenz.unzureichend": { de: "unzureichend belegt", en: "insufficient evidence" },
  "ic.expand": { de: "Aufklappen", en: "Expand" },
  "ic.collapse": { de: "Zuklappen", en: "Collapse" },

  // Warning banner
  "warn.title": { de: "Wichtige Sicherheitshinweise", en: "Important Safety Information" },
  "warn.mix.bold": { de: "Mischkonsum ist lebensgefährlich.", en: "Polysubstance use is life-threatening." },
  "warn.mix.body": {
    de: "Die Kombination mit Opioiden, Alkohol oder GHB/GBL kann zu tödlicher additiver Atemdepression führen. Die meisten tödlichen Überdosierungen mit Benzodiazepin-Beteiligung umfassen weitere Substanzen, vor allem Opioide. Risiko und Datenlage unterscheiden sich nach Region und Zeitraum.",
    en: "Combination with opioids, alcohol or GHB/GBL can cause fatal additive respiratory depression. Most fatal overdoses involving benzodiazepines include further substances, above all opioids. Risk and data differ by region and period.",
  },
  "warn.gabapentinoid.bold": { de: "Pregabalin und Gabapentin brauchen besondere Vorsicht.", en: "Pregabalin and gabapentin require particular caution." },
  "warn.gabapentinoid.body": {
    de: "Die FDA nennt Benzodiazepine als ZNS-Depressiva, bei deren Kombination mit Gabapentinoiden auf Sedierung und Atemdepression geachtet werden soll. Besonders relevant ist das bei zusätzlichen Opioiden, bei Atemwegserkrankungen, im höheren Alter und bei weiteren Risikofaktoren.",
    en: "The FDA lists benzodiazepines as CNS depressants whose combination with gabapentinoids requires monitoring for sedation and respiratory depression. This matters most with additional opioids, in respiratory disease, in older age and with further risk factors.",
  },
  "warn.stop.bold": { de: "Abruptes Absetzen kann tödlich sein.", en: "Abrupt discontinuation can be fatal." },
  "warn.stop.body": {
    de: "Nach längerem Gebrauch drohen Krampfanfälle bis hin zum Status epilepticus sowie Delir. Ein Ausschleichen ausschließlich ärztlich begleitet.",
    en: "After prolonged use, seizures up to status epilepticus and delirium can occur. Tapering must be supervised by a physician.",
  },
  "warn.disclaimer": {
    de: "Diese Seite ist Harm-Reduction-Aufklärung, keine Konsum- oder Dosierungsanleitung und kein Ersatz für ärztliche Beratung.",
    en: "This page is harm-reduction information, not a usage or dosing guide, and not a substitute for medical advice.",
  },

  // Emergency box
  "emergency.title": { de: "Im Notfall", en: "In an emergency" },
  "emergency.signs.label": { de: "Notfallzeichen:", en: "Emergency signs:" },
  "emergency.signs.body": {
    de: "Nicht weckbar, sehr langsame oder flache Atmung, bläuliche Lippen oder Nägel, schwere Verwirrtheit. Sofort 112 rufen, bei vorhandener Atmung in die stabile Seitenlage bringen und die Atmung weiter kontrollieren.",
    en: "Unrousable, very slow or shallow breathing, bluish lips or nails, severe confusion. Call emergency services immediately, place the person in the recovery position if they are breathing, and keep checking their breathing.",
  },
  "emergency.naloxone.label": { de: "Naloxon:", en: "Naloxone:" },
  "emergency.naloxone.body": {
    de: "Kehrt nur eine Opioid-Beteiligung um und hebt die Benzodiazepin-Wirkung nicht auf. Bei einer reinen Nicht-Opioid-Überdosierung schadet es in der Regel nicht, deshalb bei unklarem Verdacht geben.",
    en: "Reverses an opioid component only and does not reverse the benzodiazepine effect. In a pure non-opioid overdose it usually does no harm, so give it when opioid involvement is unclear.",
  },
  "emergency.flumazenil.label": { de: "Flumazenil ist kein Selbsthilfe-Gegenmittel:", en: "Flumazenil is not a self-help antidote:" },
  "emergency.flumazenil.body": {
    de: "Bei Abhängigkeit, gemischter oder unklarer Überdosierung und bei Krampfneigung kann es Entzugskrampfanfälle oder Rhythmusstörungen auslösen. Es gehört in professionelle toxikologische Behandlung.",
    en: "In dependence, mixed or unclear overdose and with a seizure history it can precipitate withdrawal seizures or arrhythmias. It belongs in professional toxicological care.",
  },
  "emergency.counterfeit.label": { de: "Gefälschte Tabletten:", en: "Counterfeit tablets:" },
  "emergency.counterfeit.body": {
    de: "Als \"Xanax\" oder andere Arzneimittel verkaufte Pillen können Fentanyl oder neuartige Benzodiazepine enthalten. Dann gelten die Werte in dieser Tabelle nicht.",
    en: "Pills sold as \"Xanax\" or other medicines can contain fentanyl or novel benzodiazepines. The values in this table then do not apply.",
  },
  "emergency.risk.label": { de: "Erhöhtes Risiko:", en: "Increased risk:" },
  "emergency.risk.body": {
    de: "Leber- oder Niereninsuffizienz, COPD oder Schlafapnoe, hohes Alter, Schwangerschaft und eine Krampfanamnese erfordern besondere Vorsicht. Sedierung, Koordinations- und Gedächtnisstörungen beeinträchtigen Fahrtüchtigkeit und erhöhen das Sturzrisiko.",
    en: "Liver or kidney impairment, COPD or sleep apnoea, older age, pregnancy and a seizure history require particular caution. Sedation plus coordination and memory impairment affect fitness to drive and increase the risk of falls.",
  },
  "emergency.link": { de: "Ausführliche Notfall-Kurzreferenz", en: "Full emergency quick reference" },

  // Legend footer
  "legend.title": { de: "Legende & methodische Hinweise", en: "Legend & methodological notes" },
  "legend.dot.label": { de: "Dot-Skala (0–5), redaktionell:", en: "Dot scale (0–5), editorial:" },
  "legend.dot.body": {
    de: "ordinale redaktionelle Einschätzung ohne validierte Messskala und ohne substanzspezifischen Einzelbeleg. Werte sind nicht quantitativ, nicht zwischen Substanzklassen vergleichbar, und ein Unterschied von einem Punkt ist nicht interpretierbar. Das Abhängigkeitsrisiko hängt stark von Dosis, Wirkeintritt, Einnahmedauer, Indikation und persönlichen Faktoren ab und ist keine feste Stoffeigenschaft.",
    en: "Ordinal editorial estimate without a validated measurement scale and without a substance-specific source. Values are not quantitative, not comparable across substance classes, and a one-point difference is not interpretable. Dependence risk depends heavily on dose, onset, duration of use, indication and personal factors, and is not a fixed substance property.",
  },
  "legend.equiv.label": { de: "Diazepam-Äquivalenzen:", en: "Diazepam equivalences:" },
  "legend.equiv.body": {
    de: "die Spalte nennt die ungefähre Menge, die etwa 10 mg oralem Diazepam entspricht. Das sind grobe klinische Schätzwerte aus Ashton 2007, NHS SPS und der ASAM-Leitlinie 2025. Die Quellen weichen deutlich ab, etwa Lorazepam 1 mg gegenüber 2 mg oder Triazolam 0,5 mg gegenüber 0,25 mg. Individuelle Variabilität ist hoch, Einnahmedauer, Indikation, Leber- und Nierenfunktion, Alter und aktive Metaboliten spielen mit hinein. Nicht zur exakten Umrechnung verwenden.",
    en: "The column gives the approximate amount that corresponds to roughly 10 mg oral diazepam. These are rough clinical estimates from Ashton 2007, NHS SPS and the 2025 ASAM guideline. Sources diverge noticeably, for example lorazepam 1 mg versus 2 mg or triazolam 0.5 mg versus 0.25 mg. Individual variability is high, and duration of use, indication, liver and kidney function, age and active metabolites all matter. Do not use for exact conversion.",
  },
  "legend.typicalDose.label": { de: "Typische Dosis:", en: "Typical dose:" },
  "legend.typicalDose.body": {
    de: "gängige orale Erwachsenendosen ohne Angabe von Indikation, Applikationsweg, Altersgruppe oder Zulassungsregion. Zwischen diesen Bezugsgrößen unterscheiden sich zugelassene Dosierungen erheblich. Keine Dosierungsempfehlung.",
    en: "Common oral adult doses without stating indication, route of administration, age group or licensing region. Approved dosages differ considerably between those reference points. Not a dosing recommendation.",
  },
  "legend.zdrug.label": { de: "Z-Drugs:", en: "Z-drugs:" },
  "legend.zdrug.body": {
    de: "Vergleichswerte beziehen sich rein auf die sedative Wirkung. Z-Substanzen wirken an den Benzodiazepin-Bindungsstellen des GABA-A-Rezeptors, ihre Profile unterscheiden sich aber: Zolpidem bevorzugt α1-haltige Rezeptoren, Zopiclon unterscheidet weitgehend nicht zwischen den Untereinheiten, bei Eszopiclon ist die Selektivität unsicher. Ungefähre Diazepam-Vergleichswerte existieren für Zolpidem und Zopiclon, sind aber nicht exakt. Eine Umstellung im Entzug gehört in ärztliche Hände und ist nicht immer angezeigt.",
    en: "Comparative values refer to sedative effect only. Z-drugs act at the benzodiazepine binding sites of the GABA-A receptor, but their profiles differ: zolpidem prefers α1-containing receptors, zopiclone largely does not distinguish between subunits, and for eszopiclone the selectivity is uncertain. Approximate diazepam comparison values exist for zolpidem and zopiclone but are not exact. Switching during withdrawal belongs in medical hands and is not always indicated.",
  },
  "legend.class.label": { de: "Klassen-Labels (short/intermediate/long):", en: "Class labels (short/intermediate/long):" },
  "legend.class.body": {
    de: 'quellenabhängig und nicht einheitlich definiert; maßgeblich ist der tatsächliche T½-Wert (Spalte „t½“). Alprazolam wird hier als intermediär geführt, NHS SPS zählt es zu den kurzwirksamen Benzodiazepinen. Die Halbwertszeit ist zudem nicht mit der subjektiv wahrgenommenen Wirkdauer gleichzusetzen.',
    en: 'Source-dependent and not uniformly defined; the actual t½ value (column “t½”) is decisive. Alprazolam is listed here as intermediate, while NHS SPS counts it among the short-acting benzodiazepines. Half-life is also not the same as the subjectively perceived duration of action.',
  },
  "legend.metabolite.label": { de: "Metabolit-Klammer in T½:", en: "Metabolite bracket in t½:" },
  "legend.metabolite.body": {
    de: "Werte in eckigen Klammern bezeichnen die Halbwertszeit eines klinisch relevanten aktiven Metaboliten (z.B. Nordazepam), die die effektive Wirkdauer dominiert.",
    en: "Values in square brackets denote the half-life of a clinically relevant active metabolite (e.g. nordazepam) that dominates the effective duration of action.",
  },
  "legend.midazolam.label": { de: "¹ Midazolam:", en: "¹ Midazolam:" },
  "legend.midazolam.body": {
    de: "orale Midazolam-Präparate sind für überwachte Settings bestimmt. Entscheidend sind geschultes Personal, Atemwegsmanagement und Monitoring. Wegen hohen First-Pass-Metabolismus (orale Bioverfügbarkeit ungefähr 36 bis 44 Prozent, stark variabel) ist Midazolam in den etablierten oralen Äquivalenztabellen nicht enthalten.",
    en: "Oral midazolam preparations are intended for monitored settings. What matters is trained staff, airway management and monitoring. Because of extensive first-pass metabolism (oral bioavailability roughly 36 to 44 percent, highly variable), midazolam is not included in the established oral equivalence tables.",
  },
  "legend.clonazepam.label": { de: "² Clonazepam:", en: "² Clonazepam:" },
  "legend.clonazepam.body": {
    de: "Grenzfall zwischen intermediate und long (T½ 18–50h), je nach Quelle unterschiedlich klassifiziert.",
    en: "Borderline case between intermediate and long (t½ 18–50 h); classified differently depending on the source.",
  },
  "legend.passion.label": { de: "³ Passionsblume:", en: "³ Passion flower:" },
  "legend.passion.body": {
    de: "Phytopharmakon - gänzlich andere Substanzklasse und Wirkmechanismus. Dot-Ratings sind nicht direkt mit Benzodiazepinen vergleichbar und nur zur Orientierung aufgeführt. Die Dosisangabe ist produktabhängig: Studien nutzten sehr unterschiedliche Extrakte, und ohne Extraktverhältnis und Standardisierung sind Milligrammangaben zwischen Präparaten nicht austauschbar.",
    en: "Phytopharmaceutical - entirely different substance class and mechanism of action. Dot ratings are not directly comparable to benzodiazepines and are listed for orientation only. The dose figure is product-dependent: studies used very different extracts, and without extract ratio and standardisation, milligram figures are not interchangeable between preparations.",
  },
  "legend.flunitrazepam.label": { de: "⁴ Flunitrazepam:", en: "⁴ Flunitrazepam:" },
  "legend.flunitrazepam.body": {
    de: "mit einer Halbwertszeit von 18 bis 26 Stunden und einem aktiven Metaboliten passt der Wirkstoff nicht zu einem Label \"kurz\" neben Triazolam mit rund zwei Stunden. Die Einordnung ist quellenabhängig.",
    en: "With a half-life of 18 to 26 hours and an active metabolite, this substance does not fit a \"short\" label alongside triazolam at around two hours. The classification is source-dependent.",
  },
  "legend.noequiv.label": { de: "⁵ Keine belastbare Standardäquivalenz:", en: "⁵ No reliable standard equivalence:" },
  "legend.noequiv.body": {
    de: "für Eszopiclon und Zaleplon ist in den hier genannten Referenztabellen (NHS SPS, ASAM 2025, Ashton) kein Diazepam-Äquivalent hinterlegt. Ein früher hier angezeigter fester Wert war nicht belegbar und wurde entfernt.",
    en: "For eszopiclone and zaleplon, no diazepam equivalent is filed in the reference tables named here (NHS SPS, ASAM 2025, Ashton). A fixed value previously shown here was not verifiable and has been removed.",
  },
  // Sources sheet
  "sources.button": { de: "Quellen und Belege", en: "Sources and evidence" },
  "sources.title": { de: "Quellen und Belege", en: "Sources and evidence" },
  "sources.section.verified": { de: "Belegte Quellen", en: "Documented sources" },
  "sources.section.open": { de: "Ohne hinterlegten Beleg", en: "Without a filed source" },
  "sources.section.openIntro": {
    de: "Diese Angaben stehen auf der Seite, sind aber noch nicht gegen eine zitierbare Quelle geprüft.",
    en: "These statements appear on the page but have not yet been checked against a citable source.",
  },
  "sources.backs": { de: "Belegt hier:", en: "Backs here:" },
  "sources.caveat": { de: "Einschränkung:", en: "Limitation:" },
  "sources.close": { de: "Quellen schließen", en: "Close sources" },
  "sources.disclaimer": {
    de: "Diese Seite ist Information und keine Beratung. Hinweise auf fehlende oder bessere Quellen gerne an",
    en: "This page is information, not advice. Pointers to missing or better sources are welcome at",
  },
  "sources.kind.leitlinie": { de: "Leitlinie", en: "Guideline" },
  "sources.kind.behoerde": { de: "Behörde", en: "Authority" },
  "sources.kind.fachinfo": { de: "Fachinformation", en: "Product information" },
  "sources.kind.monitoring": { de: "Monitoring", en: "Monitoring" },
  "sources.kind.sekundaerliteratur": { de: "Sekundärliteratur", en: "Secondary literature" },
  "sources.kind.primaerliteratur": { de: "Primärliteratur", en: "Primary research" },
  "sources.newTab": { de: "öffnet in neuem Tab", en: "opens in a new tab" },
} as const satisfies Record<string, Pair>;

export type StringKey = keyof typeof STRINGS;

// ---- Vocabulary mapping for benzo data values ----

// Class tokens (source values from benzo_compounds.json, suffix footnote markers preserved)
const CLASS_MAP: Record<string, Pair> = {
  "Benzodiazepine (long)": { de: "Benzodiazepin (lang)", en: "Benzodiazepine (long)" },
  "Benzodiazepine (intermediate)": { de: "Benzodiazepin (intermediär)", en: "Benzodiazepine (intermediate)" },
  "Benzodiazepine (intermediate/long)": { de: "Benzodiazepin (intermediär/lang)", en: "Benzodiazepine (intermediate/long)" },
  "Benzodiazepine (short)": { de: "Benzodiazepin (kurz)", en: "Benzodiazepine (short)" },
  "Z-Drug (imidazopyridine)": { de: "Z-Substanz (Imidazopyridin)", en: "Z-drug (imidazopyridine)" },
  "Z-Drug (cyclopyrrolone)": { de: "Z-Substanz (Cyclopyrrolon)", en: "Z-drug (cyclopyrrolone)" },
  "Z-Drug (pyrazolopyrimidine)": { de: "Z-Substanz (Pyrazolopyrimidin)", en: "Z-drug (pyrazolopyrimidine)" },
  "Phytopharmakon": { de: "Phytopharmakon", en: "Phytopharmaceutical" },
};

export function translateClass(raw: string, lang: Lang): string {
  if (!raw) return raw;
  // Split off footnote marker (¹²³⁴⁵)
  const m = raw.match(/^(.*?)([¹²³⁴⁵]?)$/);
  const base = m?.[1] ?? raw;
  const marker = m?.[2] ?? "";
  const pair = CLASS_MAP[base];
  return (pair ? pair[lang] : base) + marker;
}

// Generic value vocabulary (Onset/Duration/Lipophilicity/Yes/No prefixes)
const VOCAB: Record<string, Pair> = {
  // Lipophilicity
  "High": { de: "Hoch", en: "High" },
  "Moderate": { de: "Mittel", en: "Moderate" },
  "Low": { de: "Niedrig", en: "Low" },
  // Onset
  "Fast (0.5-1h)": { de: "Schnell (0,5–1 h)", en: "Fast (0.5–1 h)" },
  "Fast (0.5-2h)": { de: "Schnell (0,5–2 h)", en: "Fast (0.5–2 h)" },
  "Intermediate (1-4h)": { de: "Intermediär (1–4 h)", en: "Intermediate (1–4 h)" },
  "Slow (>4h)": { de: "Langsam (>4 h)", en: "Slow (>4 h)" },
  // Duration
  "Long (>24h)": { de: "Lang (>24 h)", en: "Long (>24 h)" },
  "Intermediate (6-24h)": { de: "Intermediär (6–24 h)", en: "Intermediate (6–24 h)" },
  "Short (<6h)": { de: "Kurz (<6 h)", en: "Short (<6 h)" },
  "Ultra-short (<3h)": { de: "Ultrakurz (<3 h)", en: "Ultra-short (<3 h)" },
};

export function translateVocab(raw: string | undefined | null, lang: Lang): string {
  if (raw == null) return "";
  const s = String(raw);

  // Active Metabolites: "Yes (...)" / "No"
  if (/^Yes\b/i.test(s)) return s.replace(/^Yes/i, lang === "de" ? "Ja" : "Yes");
  if (/^No\b/i.test(s)) return s.replace(/^No/i, lang === "de" ? "Nein" : "No");

  const direct = VOCAB[s];
  if (direct) return direct[lang];
  return s;
}
